module.exports = __webpack_public_path__ + "img/arrow_white.e1e523e7.svg";